/**
 * Do not edit directly
 * Generated on Fri, 27 Oct 2023 10:44:27 GMT
 */

export const mwComponentButtonFilledColorBgDefault = "#ed2985";
export const mwComponentButtonFilledColorBgHover = "#c42177";
export const mwComponentButtonFilledColorBgPressed = "#991766";
export const mwComponentButtonFilledColorBgDisabled = "#95a0a4";
export const mwComponentButtonFilledColorBgFocused = "#c42177";
export const mwComponentButtonFilledColorFgDefault = "#ffffff";
export const mwComponentButtonFilledColorFgHover = "#ffffff";
export const mwComponentButtonFilledColorFgPressed = "#EEF1F3";
export const mwComponentButtonFilledColorFgDisabled = "#EEF1F3";
export const mwComponentButtonFilledColorFgFocused = "#ffffff";
export const mwComponentButtonFilledColorOutlineFocused = "#001418";
export const mwComponentButtonOutlineGhostColorBgDefault = "#ffffff00";
export const mwComponentButtonOutlineGhostColorFgDefault = "#001418";
export const mwComponentButtonOutlineGhostColorFgHover = "#ed2985";
export const mwComponentButtonOutlineGhostColorFgPressed = "#c42177";
export const mwComponentButtonOutlineGhostColorFgDisabled = "#95a0a4";
export const mwComponentButtonOutlineGhostColorFgFocused = "#ed2985";
export const mwComponentButtonOutlineGhostColorFgInverted = "#ffffff";
export const mwComponentButtonOutlineGhostColorBorderDefault = "#001418";
export const mwComponentButtonOutlineGhostColorBorderHover = "#ed2985";
export const mwComponentButtonOutlineGhostColorBorderPressed = "#c42177";
export const mwComponentButtonOutlineGhostColorBorderDisabled = "#79868b";
export const mwComponentButtonOutlineGhostColorBorderFocused = "#001418";
export const mwComponentButtonBorderWidthOutlineDefault = 1;
export const mwComponentButtonBorderWidthOutlineFocused = 2;
export const mwComponentButtonBorderWidthFilledDefault = "0px";
export const mwComponentButtonBorderWidthFilledFocused = 2;
export const mwComponentButtonBorderWidthGhostDefault = "0px";
export const mwComponentButtonBorderWidthGhostFocused = 2;
export const mwComponentButtonBorderRadiusDefault = 9999;
export const mwComponentButtonSmPaddingX = "16px";
export const mwComponentButtonSmPaddingY = "4px";
export const mwComponentButtonSmPaddingIcon = "8px";
export const mwComponentButtonSmGapWithin = "8px";
export const mwComponentButtonSmGapBetween = "8px";
export const mwComponentButtonMdPaddingX = "24px";
export const mwComponentButtonMdPaddingY = "8px";
export const mwComponentButtonMdPaddingIcon = "12px";
export const mwComponentButtonMdGapWithin = "12px";
export const mwComponentButtonMdGapBetween = "12px";
export const mwComponentButtonLgPaddingX = "32px";
export const mwComponentButtonLgPaddingY = "12px";
export const mwComponentButtonLgPaddingIcon = "16px";
export const mwComponentButtonLgGapWithin = "16px";
export const mwComponentButtonLgGapBetween = "16px";
export const mwComponentButtonXlPaddingX = "48px";
export const mwComponentButtonXlPaddingY = "20px";
export const mwComponentButtonXlPaddingIcon = "20px";
export const mwComponentButtonXlGapWithin = "20px";
export const mwComponentButtonXlGapBetween = "20px";
export const mwComponentButtonLabelSmFontFamily = "Poppins";
export const mwComponentButtonLabelSmFontWeight = 600;
export const mwComponentButtonLabelSmFontSize = "14px";
export const mwComponentButtonLabelSmLineHeight = "20px";
export const mwComponentButtonLabelMdFontFamily = "Poppins";
export const mwComponentButtonLabelMdFontWeight = 700;
export const mwComponentButtonLabelMdLineHeight = "24px";
export const mwComponentButtonLabelMdFontSize = "16px";
export const mwComponentButtonLabelLgFontFamily = "Poppins";
export const mwComponentButtonLabelLgFontWeight = 700;
export const mwComponentButtonLabelLgLineHeight = "24px";
export const mwComponentButtonLabelLgFontSize = "20px";
export const mwComponentButtonLabelXlFontFamily = "Poppins";
export const mwComponentButtonLabelXlFontWeight = 700;
export const mwComponentButtonLabelXlLineHeight = "24px";
export const mwComponentButtonLabelXlFontSize = "24px";
export const mwComponentLinkTypoFontFamily = "Poppins";
export const mwComponentLinkTypoFontWeight = 400;
export const mwComponentLinkTypoFontSize = "16px";
export const mwComponentLinkTypoLineHeight = "24px";
export const mwComponentLinkColorFgDefault = "#001418";
export const mwComponentLinkColorFgHover = "#ed2985";
export const mwComponentLinkColorFgPressed = "#c42177";
export const mwComponentLinkColorFgFocused = "#ed2985";
export const mwComponentSizeButtonHeightMinW = "88px";
export const mwComponentSizeButtonHeightSm = 28;
export const mwComponentSizeButtonHeightMd = 40;
export const mwComponentSizeButtonHeightLg = 52;
export const mwComponentSizeButtonHeightXl = 64;
export const mwComponentSizeButtonIconXs = "12px";
export const mwComponentSizeButtonIconSm = "14px";
export const mwComponentSizeButtonIconMd = "20px";
export const mwComponentSizeButtonIconLg = "24px";
export const mwComponentSizeButtonIconXl = "32px";
export const mwComponentSizeSwitchDefaultW = "52px";
export const mwComponentSizeSwitchDefaultH = 28;
export const mwComponentSizeControlsCheckboxRadioContainer = "24px";
export const mwComponentSizeControlsRadioOutline = "20px";
export const mwComponentSizeControlsRadioFill = "8px";
export const mwComponentSizeControlsCheckboxBox = "20px";
export const mwComponentSizeTextFieldMinW = "120px";
export const mwComponentSizeTextFieldLabelHorizontalWidth = "120px";
export const mwComponentSizeSliderLabelHorizontalWidth = "120px";
export const mwComponentSizeSliderHandle = 20;
export const mwComponentSizeSliderTrackH = "4px";
export const mwComponentSizeChipsIcons = "20px";
export const mwComponentSizeChipsMinW = "64px";
export const mwComponentSizeChipsHeight = "32px";
export const mwComponentSizeTabsDefaultH = "48px";
export const mwComponentSizeTabsWithIconH = "64px";
export const mwComponentSizeMenuItemDefaultH = "56px";
export const mwComponentSizeAvatarsXs = "20px";
export const mwComponentSizeAvatarsSm = "24px";
export const mwComponentSizeAvatarsMd = "40px";
export const mwComponentSizeAvatarsLg = "56px";
export const mwComponentSizeAvatarsIconXs = "12px";
export const mwComponentSizeAvatarsIconSm = "16px";
export const mwComponentSizeAvatarsIconMd = "24px";
export const mwComponentSizeAvatarsIconLg = "32px";
export const mwComponentSizeAvatarsIconXl = "48px";
export const mwComponentSizeAppBarHeight = "72px";
export const mwComponentSizeModalDefaultW = "800px";
export const mwComponentSizeModalSmallW = "480px";
export const mwComponentSizePopoverDefaultW = "256px";
export const mwComponentSizePopoverDefaultH = "96px";
export const mwComponentControlsColorFgDefault = "#ffffff";
export const mwComponentControlsColorFgDisabled = "#EEF1F3";
export const mwComponentControlsColorFgOff = "#001418";
export const mwComponentControlsColorBgSelected = "#ed2985";
export const mwComponentControlsColorBgDisabled = "#95a0a4";
export const mwComponentControlsColorBgHover = "#c42177";
export const mwComponentControlsColorBgFocused = "#c42177";
export const mwComponentControlsColorBgPressed = "#991766";
export const mwComponentControlsColorBgUnselected = "#ffffff00";
export const mwComponentControlsColorOutlineDefault = "#001418";
export const mwComponentControlsColorOutlineDisabled = "#79868b";
export const mwComponentControlsColorLabelDefault = "#001418";
export const mwComponentControlsColorLabelDisabled = "#95a0a4";
export const mwComponentControlsPaddingAll = "0px";
export const mwComponentControlsBorderWidthSelected = "0px";
export const mwComponentControlsBorderWidthFocused = 2;
export const mwComponentControlsBorderWidthUnselected = 2;
export const mwComponentControlsMarginMarginLeft = "32px";
export const mwComponentCheckboxBorderRadius = 2;
export const mwComponentControlsWithLabelGap = "12px";
export const mwComponentControlsWithLabelPaddingY = "12px";
export const mwComponentControlsWithLabelPaddingL = "0px";
export const mwComponentControlsWithLabelPaddingR = "12px";
export const mwComponentControlLabelFontFamily = "Poppins";
export const mwComponentControlLabelFontWeight = 400;
export const mwComponentControlLabelFontSize = "16px";
export const mwComponentControlLabelLineHeight = "24px";
export const mwComponentTextFieldLabelFontFamily = "Poppins";
export const mwComponentTextFieldLabelFontWeight = 400;
export const mwComponentTextFieldLabelFontSize = "14px";
export const mwComponentTextFieldLabelLineHeight = "20px";
export const mwComponentTextFieldHelperTextFontFamily = "Poppins";
export const mwComponentTextFieldHelperTextFontWeight = 400;
export const mwComponentTextFieldHelperTextFontSize = "14px";
export const mwComponentTextFieldHelperTextLineHeight = "20px";
export const mwComponentTextFieldTextFontFamily = "Poppins";
export const mwComponentTextFieldTextFontWeight = 400;
export const mwComponentTextFieldTextFontSize = "16px";
export const mwComponentTextFieldTextLineHeight = "24px";
export const mwComponentTextFieldFgDefault = "#001418";
export const mwComponentTextFieldFgHelperText = "#B1BABE";
export const mwComponentTextFieldFgPlaceholder = "#44555b";
export const mwComponentTextFieldFgDisabled = "#95a0a4";
export const mwComponentTextFieldFgError = "#9f1b00";
export const mwComponentTextFieldFgRequired = "#9f1b00";
export const mwComponentTextFieldFgIconDefault = "#44555b";
export const mwComponentTextFieldFgIconFocused = "#ed2985";
export const mwComponentTextFieldBgDefault = "#EEF1F3";
export const mwComponentTextFieldBgHover = "#ffffff";
export const mwComponentTextFieldBgError = "#FCBAB7";
export const mwComponentTextFieldBorderDefault = "#B1BABE";
export const mwComponentTextFieldBorderFocused = "#001418";
export const mwComponentTextFieldDefault = 1;
export const mwComponentTextFieldGapGroupVertical = "2px";
export const mwComponentTextFieldGapHorizontalGapBetween = "12px";
export const mwComponentTextFieldGapHorizontalGapWithin = "8px";
export const mwComponentTextFieldPaddingTextFieldX = "16px";
export const mwComponentTextFieldPaddingTextFieldY = "8px";
export const mwComponentTextFieldPaddingHelperTextY = "4px";
export const mwComponentTextFieldPaddingHelperTextL = "16px";
export const mwComponentTextFieldPaddingLabelVerticalX = "16px";
export const mwComponentTextFieldPaddingLabelHorizontal = "0px";
export const mwComponentTextFieldFocused = 2;
export const mwComponentSliderWithLabelGapWithinY = "8px";
export const mwComponentSliderPaddingLabelX = "0px";
export const mwComponentSliderHandleHoverGapBetween = "4px";
export const mwComponentSliderLabelFontFamily = "Poppins";
export const mwComponentSliderLabelFontWeight = 400;
export const mwComponentSliderLabelFontSize = "12px";
export const mwComponentSliderLabelLineHeight = "16px";
export const mwComponentSliderLabelTextCase = "uppercase";
export const mwComponentSliderLabelLetterSpacing = "calc((1em / 100) * 2)";
export const mwComponentSliderBorderFocused = {"color":"#001418","width":"2px"};
export const mwComponentSliderDefaultActive = "#ed2985";
export const mwComponentSliderHover = "#c42177";
export const mwComponentSliderDisabled = "#95a0a4";
export const mwComponentSliderFocus = "#c42177";
export const mwComponentSliderDisabledInactive = "#CFD6D8";
export const mwComponentSliderDefaultInactive = "#F9E2EE";
export const mwComponentSliderFg = "#ffffff";
export const mwComponentSliderPressed = "#991766";
export const mwComponentSliderIconsDefault = "#44555b";
export const mwComponentMenuItemTitleFontFamily = "Poppins";
export const mwComponentMenuItemTitleFontWeight = 400;
export const mwComponentMenuItemTitleFontSize = "16px";
export const mwComponentMenuItemTitleLineHeight = "24px";
export const mwComponentMenuItemSubtitleFontFamily = "Poppins";
export const mwComponentMenuItemSubtitleFontWeight = 400;
export const mwComponentMenuItemSubtitleFontSize = "14px";
export const mwComponentMenuItemSubtitleLineHeight = "20px";
export const mwComponentMenuItemBorderRadius = 4;
export const mwComponentMenuItemBorderWidthDefault = "0px";
export const mwComponentMenuItemBorderWidthFocused = 2;
export const mwComponentMenuItemFgTitle = "#001418";
export const mwComponentMenuItemFgSubtitle = "#44555b";
export const mwComponentMenuItemFgSelected = "#ed2985";
export const mwComponentMenuItemFgDisabled = "#95a0a4";
export const mwComponentMenuItemFgHover = "#ed2985";
export const mwComponentMenuItemFgFocused = "#ed2985";
export const mwComponentMenuItemFgPressed = "#991766";
export const mwComponentMenuItemBgDefault = "#ffffff";
export const mwComponentMenuItemBorderFocused = "#001418";
export const mwComponentMenuItemGapBetween = "0px";
export const mwComponentListItemTitleFontFamily = "Poppins";
export const mwComponentListItemTitleFontWeight = 400;
export const mwComponentListItemTitleFontSize = "16px";
export const mwComponentListItemTitleLineHeight = "24px";
export const mwComponentListItemSubtitleFontFamily = "Poppins";
export const mwComponentListItemSubtitleFontWeight = 400;
export const mwComponentListItemSubtitleFontSize = "14px";
export const mwComponentListItemSubtitleLineHeight = "20px";
export const mwComponentListItemBorderRadius = 4;
export const mwComponentListItemFgTitle = "#001418";
export const mwComponentListItemFgSupportingText = "#44555b";
export const mwComponentListItemFgDisabled = "#95a0a4";
export const mwComponentListItemFgHover = "#ed2985";
export const mwComponentListItemFgPressed = "#991766";
export const mwComponentListItemBgDefault = "#ffffff";
export const mwComponentListItemBgSelected = "#F9E2EE";
export const mwComponentListItemBgTransparent = "#ffffff00";
export const mwComponentListItemBorderFocused = {"color":"#001418","width":"2px"};
export const mwComponentListItem1LineH = "56px";
export const mwComponentListItem2LineH = "72px";
export const mwComponentListItemGapWithin = "16px";
export const mwComponentListItemPaddingL = "24px";
export const mwComponentListItemPaddingR = "24px";
export const mwComponentListItem3LinePaddingY = "12px";
export const mwComponentListItemGapBetween = "0px";
export const mwComponentMenuShadow0X = 0;
export const mwComponentMenuShadow0Y = "5px";
export const mwComponentMenuShadow0Blur = "5px";
export const mwComponentMenuShadow0Spread = "-3px";
export const mwComponentMenuShadow0Color = "#00000033";
export const mwComponentMenuShadow0Type = "dropShadow";
export const mwComponentMenuShadow1X = 0;
export const mwComponentMenuShadow1Y = "8px";
export const mwComponentMenuShadow1Blur = "10px";
export const mwComponentMenuShadow1Spread = "1px";
export const mwComponentMenuShadow1Color = "#00000024";
export const mwComponentMenuShadow1Type = "dropShadow";
export const mwComponentMenuShadow2X = 0;
export const mwComponentMenuShadow2Y = "3px";
export const mwComponentMenuShadow2Blur = "14px";
export const mwComponentMenuShadow2Spread = "2px";
export const mwComponentMenuShadow2Color = "#0000001f";
export const mwComponentMenuShadow2Type = "dropShadow";
export const mwComponentDividerFgDefault = "#B1BABE";
export const mwComponentDividerInset = "16px";
export const mwComponentDividerBorderWidthDefault = 1;
export const mwComponentChipsTypoFontFamily = "Poppins";
export const mwComponentChipsTypoFontWeight = 500;
export const mwComponentChipsTypoLineHeight = "16px";
export const mwComponentChipsTypoFontSize = "14px";
export const mwComponentChipsPaddingX = "12px";
export const mwComponentChipsBorderWidthDefault = 1;
export const mwComponentChipsBorderWidthFocused = 2;
export const mwComponentChipsColorBorderDefault = "#44555b";
export const mwComponentChipsColorBorderDisabled = "#79868b";
export const mwComponentChipsColorBorderSelected = "#ed2985";
export const mwComponentChipsColorFgDefault = "#44555b";
export const mwComponentChipsColorFgHover = "#44555b";
export const mwComponentChipsColorFgDisabled = "#95a0a4";
export const mwComponentChipsColorFgSelected = "#ed2985";
export const mwComponentChipsColorBgDefault = "#ffffff";
export const mwComponentChipsColorBgHover = "#EEF1F3";
export const mwComponentChipsColorBgPressed = "#CFD6D8";
export const mwComponentChipsBorderRadius = 12;
export const mwComponentChipsGapWithin = "8px";
export const mwComponentChipsGapBetweenX = "8px";
export const mwComponentChipsGapBetweenY = "12px";
export const mwComponentAvatarsColorBgDefault = "#991766";
export const mwComponentAvatarsColorFgDefault = "#ffffff";
export const mwComponentAvatarsTypoXsFontFamily = "Poppins";
export const mwComponentAvatarsTypoXsFontWeight = 400;
export const mwComponentAvatarsTypoXsLineHeight = "16px";
export const mwComponentAvatarsTypoXsFontSize = "10px";
export const mwComponentAvatarsTypoSmFontFamily = "Poppins";
export const mwComponentAvatarsTypoSmFontWeight = 400;
export const mwComponentAvatarsTypoSmLineHeight = "16px";
export const mwComponentAvatarsTypoSmFontSize = "14px";
export const mwComponentAvatarsTypoMdFontFamily = "Poppins";
export const mwComponentAvatarsTypoMdFontWeight = 400;
export const mwComponentAvatarsTypoMdLineHeight = "48px";
export const mwComponentAvatarsTypoMdFontSize = "24px";
export const mwComponentAvatarsTypoLgFontFamily = "Poppins";
export const mwComponentAvatarsTypoLgFontWeight = 400;
export const mwComponentAvatarsTypoLgLineHeight = "48px";
export const mwComponentAvatarsTypoLgFontSize = "32px";
export const mwComponentCardBgDefault = "#FAFAFA";
export const mwComponentCardBorderRadius = 12;
export const mwComponentCardShadowElevated0X = 0;
export const mwComponentCardShadowElevated0Y = "5px";
export const mwComponentCardShadowElevated0Blur = "5px";
export const mwComponentCardShadowElevated0Spread = "-3px";
export const mwComponentCardShadowElevated0Color = "#00000033";
export const mwComponentCardShadowElevated0Type = "dropShadow";
export const mwComponentCardShadowElevated1X = 0;
export const mwComponentCardShadowElevated1Y = "8px";
export const mwComponentCardShadowElevated1Blur = "10px";
export const mwComponentCardShadowElevated1Spread = "1px";
export const mwComponentCardShadowElevated1Color = "#00000024";
export const mwComponentCardShadowElevated1Type = "dropShadow";
export const mwComponentCardShadowElevated2X = 0;
export const mwComponentCardShadowElevated2Y = "3px";
export const mwComponentCardShadowElevated2Blur = "14px";
export const mwComponentCardShadowElevated2Spread = "2px";
export const mwComponentCardShadowElevated2Color = "#0000001f";
export const mwComponentCardShadowElevated2Type = "dropShadow";
export const mwComponentCardShadowOutlined0X = 0;
export const mwComponentCardShadowOutlined0Y = 0;
export const mwComponentCardShadowOutlined0Blur = 0;
export const mwComponentCardShadowOutlined0Spread = 0;
export const mwComponentCardShadowOutlined0Color = "#00000033";
export const mwComponentCardShadowOutlined0Type = "dropShadow";
export const mwComponentCardShadowOutlined1X = 0;
export const mwComponentCardShadowOutlined1Y = 0;
export const mwComponentCardShadowOutlined1Blur = 0;
export const mwComponentCardShadowOutlined1Spread = 0;
export const mwComponentCardShadowOutlined1Color = "#00000024";
export const mwComponentCardShadowOutlined1Type = "dropShadow";
export const mwComponentCardShadowOutlined2X = 0;
export const mwComponentCardShadowOutlined2Y = 0;
export const mwComponentCardShadowOutlined2Blur = 0;
export const mwComponentCardShadowOutlined2Spread = 0;
export const mwComponentCardShadowOutlined2Color = "#0000001f";
export const mwComponentCardShadowOutlined2Type = "dropShadow";
export const mwComponentCardBorderWidthElevated = "0px";
export const mwComponentCardBorderWidthOutlined = 1;
export const mwComponentCardBorderOutlined = "#44555b";
export const mwComponentCardHeaderFontFamily = "Poppins";
export const mwComponentCardHeaderFontWeight = 600;
export const mwComponentCardHeaderFontSize = "16px";
export const mwComponentCardHeaderLineHeight = "24px";
export const mwComponentCardTitleFontFamily = "Poppins";
export const mwComponentCardTitleFontWeight = 400;
export const mwComponentCardTitleFontSize = "24px";
export const mwComponentCardTitleLineHeight = "36px";
export const mwComponentCardSubheadFontFamily = "Poppins";
export const mwComponentCardSubheadFontWeight = 400;
export const mwComponentCardSubheadFontSize = "16px";
export const mwComponentCardSubheadLineHeight = "24px";
export const mwComponentCardSubtitleFontFamily = "Poppins";
export const mwComponentCardSubtitleFontWeight = 400;
export const mwComponentCardSubtitleFontSize = "16px";
export const mwComponentCardSubtitleLineHeight = "24px";
export const mwComponentCardMetadataFontFamily = "Poppins";
export const mwComponentCardMetadataFontWeight = 400;
export const mwComponentCardMetadataFontSize = "14px";
export const mwComponentCardMetadataLineHeight = "20px";
export const mwComponentCardFgDefault = "#001418";
export const mwComponentCardFgMuted = "#44555b";
export const mwComponentCardPaddingComponentsXDefault = "24px";
export const mwComponentCardPaddingComponentsYDefault = "24px";
export const mwComponentCardPaddingFooterTDefault = "24px";
export const mwComponentCardPaddingBDefault = "24px";
export const mwComponentModalPaddingBDefault = "24px";
export const mwComponentModalBgDefault = "#FAFAFA";
export const mwComponentModalBorderRadius = 8;
export const mwComponentModalShadowDefault0X = 0;
export const mwComponentModalShadowDefault0Y = "11px";
export const mwComponentModalShadowDefault0Blur = "15px";
export const mwComponentModalShadowDefault0Spread = "-7px";
export const mwComponentModalShadowDefault0Color = "#00000033";
export const mwComponentModalShadowDefault0Type = "dropShadow";
export const mwComponentModalShadowDefault1X = 0;
export const mwComponentModalShadowDefault1Y = "24px";
export const mwComponentModalShadowDefault1Blur = "38px";
export const mwComponentModalShadowDefault1Spread = "3px";
export const mwComponentModalShadowDefault1Color = "#00000024";
export const mwComponentModalShadowDefault1Type = "dropShadow";
export const mwComponentModalShadowDefault2X = 0;
export const mwComponentModalShadowDefault2Y = "9px";
export const mwComponentModalShadowDefault2Blur = "46px";
export const mwComponentModalShadowDefault2Spread = "8px";
export const mwComponentModalShadowDefault2Color = "#0000001f";
export const mwComponentModalShadowDefault2Type = "dropShadow";
export const mwComponentModalDescriptionFontFamily = "Poppins";
export const mwComponentModalDescriptionFontWeight = 400;
export const mwComponentModalDescriptionFontSize = "16px";
export const mwComponentModalDescriptionLineHeight = "24px";
export const mwComponentModalFgDefault = "#001418";
export const mwComponentModalFgMuted = "#44555b";
export const mwComponentModalPaddingComponentsXDefault = "24px";
export const mwComponentModalPaddingComponentsYDefault = "24px";
export const mwComponentModalPaddingFooterTDefault = "24px";
export const mwComponentModalAppBarGapWithin = "24px";
export const mwComponentModalBackdrop = "#44555b";
export const mwComponentModalMarginT = "96px";
export const mwComponentModalMarginX = "24px";
export const mwComponentModalTitleFontFamily = "Poppins";
export const mwComponentModalTitleFontWeight = 400;
export const mwComponentModalTitleLineHeight = "36px";
export const mwComponentModalTitleFontSize = "24px";
export const mwComponentTabsFgSelected = "#ed2985";
export const mwComponentTabsFgDefault = "#44555b";
export const mwComponentTabsFgDisabled = "#95a0a4";
export const mwComponentTabsLabelFontFamily = "Poppins";
export const mwComponentTabsLabelFontWeight = 500;
export const mwComponentTabsLabelLineHeight = "20px";
export const mwComponentTabsLabelFontSize = "14px";
export const mwComponentTabsBgDefault = "#FAFAFA";
export const mwComponentTabsBgHover = "#EEF1F3";
export const mwComponentTabsBgPressed = "#CFD6D8";
export const mwComponentTabsPaddingX = "24px";
export const mwComponentTabsGapWithin = "4px";
export const mwComponentTabsBorderFocused = {"color":"#ed2985","width":"2px"};
export const mwComponentAppBarPaddingX = "24px";
export const mwComponentAppBarGapWithin = "12px";
export const mwComponentAppBarBgDefault = "#1e194b";
export const mwComponentAppBarFgDefault = "#ffffff";
export const mwComponentAppBarTitleFontFamily = "Poppins";
export const mwComponentAppBarTitleFontWeight = 400;
export const mwComponentAppBarTitleLineHeight = "48px";
export const mwComponentAppBarTitleFontSize = "24px";
export const mwComponentLogInTitleFontFamily = "Poppins";
export const mwComponentLogInTitleFontWeight = 600;
export const mwComponentLogInTitleLineHeight = "60px";
export const mwComponentLogInTitleFontSize = "40px";
export const mwComponentLogInTitleLetterSpacing = "calc((1em / 100) * -2)";
export const mwComponentLogInMarginXy = "64px";
export const mwComponentLogInContentGapWithin = "16px";
export const mwComponentLogInSignUpGapWithin = "4px";
export const mwComponentLogInBgDefault = "#ffffff";
export const mwComponentAccordeonBgDefault = "#ffffff00";
export const mwComponentImagePaddingX = "24px";
export const mwComponentImageColorFg = "#ffffff";
export const mwComponentImageColorBg = "#CFD6D8";
export const mwComponentPopoverTitleFontFamily = "Poppins";
export const mwComponentPopoverTitleFontWeight = 600;
export const mwComponentPopoverTitleFontSize = "14px";
export const mwComponentPopoverTitleLineHeight = "20px";
export const mwComponentPopoverDescriptionFontFamily = "Poppins";
export const mwComponentPopoverDescriptionFontWeight = 400;
export const mwComponentPopoverDescriptionFontSize = "14px";
export const mwComponentPopoverDescriptionLineHeight = "20px";
export const mwComponentPopoverShadowDefault0X = 0;
export const mwComponentPopoverShadowDefault0Y = "3px";
export const mwComponentPopoverShadowDefault0Blur = "1px";
export const mwComponentPopoverShadowDefault0Spread = "-2px";
export const mwComponentPopoverShadowDefault0Color = "#00000033";
export const mwComponentPopoverShadowDefault0Type = "dropShadow";
export const mwComponentPopoverShadowDefault1X = 0;
export const mwComponentPopoverShadowDefault1Y = "2px";
export const mwComponentPopoverShadowDefault1Blur = "2px";
export const mwComponentPopoverShadowDefault1Spread = 0;
export const mwComponentPopoverShadowDefault1Color = "#00000024";
export const mwComponentPopoverShadowDefault1Type = "dropShadow";
export const mwComponentPopoverShadowDefault2X = 0;
export const mwComponentPopoverShadowDefault2Y = "1px";
export const mwComponentPopoverShadowDefault2Blur = "5px";
export const mwComponentPopoverShadowDefault2Spread = 0;
export const mwComponentPopoverShadowDefault2Color = "#0000001f";
export const mwComponentPopoverShadowDefault2Type = "dropShadow";
export const mwComponentPopoverBorderRadius = 4;
export const mwComponentPopoverBgDefault = "#FAFAFA";
export const mwComponentPopoverFgCopyDefault = "#001418";
export const mwComponentPopoverFgCopyMuted = "#44555b";
export const mwComponentPopoverPaddingX = "12px";
export const mwComponentPopoverGapWithin = "8px";
export const mwComponentPopoverArrowPadding = "16px";
export const mwSemanticColorBorderDisabled = "#79868b";
export const mwSemanticColorBorderDefault = "#001418";
export const mwSemanticColorBorderSubtle = "#B1BABE";
export const mwSemanticColorBorderMuted = "#44555b";
export const mwSemanticColorBorderOnDark = "#ffffff";
export const mwSemanticColorFgDefault = "#001418";
export const mwSemanticColorFgMuted = "#44555b";
export const mwSemanticColorFgSubtle = "#B1BABE";
export const mwSemanticColorFgDisabled = "#95a0a4";
export const mwSemanticColorFgOnAccent = "#ffffff";
export const mwSemanticColorFgOnDisabled = "#EEF1F3";
export const mwSemanticColorFgOnPressed = "#EEF1F3";
export const mwSemanticColorFgOnDark = "#ffffff";
export const mwSemanticColorBgDefault = "#ffffff";
export const mwSemanticColorBgMuted = "#CFD6D8";
export const mwSemanticColorBgSubtle = "#EEF1F3";
export const mwSemanticColorBgCanvas = "#FAFAFA";
export const mwSemanticColorBgDisabled = "#95a0a4";
export const mwSemanticColorBgOverlay = "#000000";
export const mwSemanticColorBgTransparent = "#ffffff00";
export const mwSemanticColorAccentPrimaryDefault = "#ed2985";
export const mwSemanticColorAccentPrimaryMuted = "#c42177";
export const mwSemanticColorAccentPrimaryIntense = "#991766";
export const mwSemanticColorAccentPrimarySubtle = "#F9E2EE";
export const mwSemanticColorAccentPrimaryDisabled = "#CFD6D8";
export const mwSemanticColorAccentSecondaryDefault = "#1e194b";
export const mwSemanticColorErrorBg = "#FCBAB7";
export const mwSemanticColorErrorDefault = "#cb2400";
export const mwSemanticColorErrorIntense = "#E51B00";
export const mwSemanticColorErrorMuted = "#FF4433";
export const mwSemanticColorErrorFg = "#9f1b00";
export const mwSemanticColorErrorSubtle = "#FDD5D3";
export const mwSemanticColorErrorOnError = "#ffffff";
export const mwSemanticColorWarningBg = "#FAE39E";
export const mwSemanticColorWarningDefault = "#FFC533";
export const mwSemanticColorWarningIntense = "#FFB218";
export const mwSemanticColorWarningFg = "#975c0b";
export const mwSemanticColorWarningMuted = "#DD8916";
export const mwSemanticColorWarningSubtle = "#FBEDBB";
export const mwSemanticColorWarningOnWarning = "#000000";
export const mwSemanticColorInfoBg = "#97E0FC";
export const mwSemanticColorInfoDefault = "#0bd2ff";
export const mwSemanticColorInfoIntense = "#02beed";
export const mwSemanticColorInfoFg = "#068eb7";
export const mwSemanticColorInfoMuted = "#04a5d2";
export const mwSemanticColorInfoSubtle = "#C8EBFD";
export const mwSemanticColorInfoOnInfo = "#000000";
export const mwSemanticColorSuccessBg = "#74FB86";
export const mwSemanticColorSuccessDefault = "#3cfa50";
export const mwSemanticColorSuccessIntense = "#03d303";
export const mwSemanticColorSuccessFg = "#2a8000";
export const mwSemanticColorSuccessMuted = "#15b300";
export const mwSemanticColorSuccessSubtle = "#B4FDC1";
export const mwSemanticColorSuccessOnSuccess = "#000000";
export const mwSemanticFontLineHeightBodyRegular = "24px";
export const mwSemanticFontLineHeightSubtitleRegular = "48px";
export const mwSemanticFontLineHeightTitleBold = "28px";
export const mwSemanticFontLineHeightTitleRegular = "28px";
export const mwSemanticFontLineHeightH1Bold = "108px";
export const mwSemanticFontLineHeightH2Bold = "96px";
export const mwSemanticFontLineHeightH3Bold = "84px";
export const mwSemanticFontLineHeightH4Bold = "72px";
export const mwSemanticFontLineHeightH5Regular = "60px";
export const mwSemanticFontLineHeightH6Bold = "48px";
export const mwSemanticFontLineHeightCaptionRegular = "48px";
export const mwSemanticFontLineHeightLabelRegular = "16px";
export const mwSemanticFontLineHeightOverlineRegular = "16px";
export const mwSemanticFontFontSizeBodyRegular = "16px";
export const mwSemanticFontFontSizeHeroRegular = "112px";
export const mwSemanticFontFontSizeH1Regular = "72px";
export const mwSemanticFontFontSizeH3Regular = "56px";
export const mwSemanticFontFontSizeH2Regular = "64px";
export const mwSemanticFontFontSizeSubtitleRegular = "24px";
export const mwSemanticFontFontSizeTitleBold = "24px";
export const mwSemanticFontFontSizeTitleRegular = "24px";
export const mwSemanticFontFontSizeLabelSm = "14px";
export const mwSemanticFontFontSizeLabelXs = "12px";
export const mwSemanticFontFontSizeLabelMd = "16px";
export const mwSemanticFontFontSizeLabelLg = "20px";
export const mwSemanticFontFontSizeLabelXl = "24px";
export const mwSemanticFontFontSizeCaptionRegular = "14px";
export const mwSemanticFontFontSizeOverlineRegular = "10px";
export const mwSemanticFontFontSizeH4Regular = "48px";
export const mwSemanticFontFontSizeH5Regular = "40px";
export const mwSemanticFontFontSizeH6Regular = "32px";
export const mwSemanticHeroFontFamily = "Poppins";
export const mwSemanticHeroFontWeight = 700;
export const mwSemanticHeroLineHeight = "120px";
export const mwSemanticHeroFontSize = "112px";
export const mwSemanticH1FontFamily = "Poppins";
export const mwSemanticH1FontWeight = 400;
export const mwSemanticH1LineHeight = "108px";
export const mwSemanticH1FontSize = "72px";
export const mwSemanticH2FontFamily = "Poppins";
export const mwSemanticH2FontWeight = 400;
export const mwSemanticH2LineHeight = "96px";
export const mwSemanticH2FontSize = "64px";
export const mwSemanticH2LetterSpacing = "calc((1em / 100) * -2)";
export const mwSemanticH3FontFamily = "Poppins";
export const mwSemanticH3FontWeight = 600;
export const mwSemanticH3LineHeight = "84px";
export const mwSemanticH3FontSize = "56px";
export const mwSemanticH3LetterSpacing = "calc((1em / 100) * -2)";
export const mwSemanticH4FontFamily = "Poppins";
export const mwSemanticH4FontWeight = 600;
export const mwSemanticH4LineHeight = "72px";
export const mwSemanticH4FontSize = "48px";
export const mwSemanticH4LetterSpacing = "calc((1em / 100) * )";
export const mwSemanticH5FontFamily = "Poppins";
export const mwSemanticH5FontWeight = 600;
export const mwSemanticH5LineHeight = "60px";
export const mwSemanticH5FontSize = "40px";
export const mwSemanticH5LetterSpacing = "calc((1em / 100) * -2)";
export const mwSemanticH6FontFamily = "Poppins";
export const mwSemanticH6FontWeight = 700;
export const mwSemanticH6LineHeight = "36px";
export const mwSemanticH6FontSize = "24px";
export const mwSemanticH6LetterSpacing = "calc((1em / 100) * -2)";
export const mwSemanticTitleBoldFontFamily = "Poppins";
export const mwSemanticTitleBoldFontWeight = 600;
export const mwSemanticTitleBoldFontSize = "20px";
export const mwSemanticTitleBoldLineHeight = "28px";
export const mwSemanticTitleBoldTextCase = "";
export const mwSemanticTitleRegularFontFamily = "Poppins";
export const mwSemanticTitleRegularFontWeight = 400;
export const mwSemanticTitleRegularFontSize = "20px";
export const mwSemanticTitleRegularLineHeight = "28px";
export const mwSemanticTitleRegularTextCase = "";
export const mwSemanticBodyBoldFontFamily = "Poppins";
export const mwSemanticBodyBoldFontWeight = 600;
export const mwSemanticBodyBoldFontSize = "16px";
export const mwSemanticBodyBoldLineHeight = "24px";
export const mwSemanticBodyRegularFontFamily = "Poppins";
export const mwSemanticBodyRegularFontWeight = 400;
export const mwSemanticBodyRegularFontSize = "16px";
export const mwSemanticBodyRegularLineHeight = "24px";
export const mwSemanticSubtitleBoldFontFamily = "Poppins";
export const mwSemanticSubtitleBoldFontWeight = 600;
export const mwSemanticSubtitleBoldFontSize = "14px";
export const mwSemanticSubtitleBoldLineHeight = "20px";
export const mwSemanticSubtitleRegularFontFamily = "Poppins";
export const mwSemanticSubtitleRegularFontWeight = 400;
export const mwSemanticSubtitleRegularFontSize = "14px";
export const mwSemanticSubtitleRegularLineHeight = "20px";
export const mwSemanticCaptionBoldFontFamily = "Poppins";
export const mwSemanticCaptionBoldFontWeight = 600;
export const mwSemanticCaptionBoldFontSize = "12px";
export const mwSemanticCaptionBoldLineHeight = "16px";
export const mwSemanticCaptionBoldTextCase = "uppercase";
export const mwSemanticCaptionBoldLetterSpacing = "calc((1em / 100) * 2)";
export const mwSemanticCaptionRegularFontFamily = "Poppins";
export const mwSemanticCaptionRegularFontWeight = 400;
export const mwSemanticCaptionRegularFontSize = "12px";
export const mwSemanticCaptionRegularLineHeight = "16px";
export const mwSemanticCaptionRegularTextCase = "uppercase";
export const mwSemanticCaptionRegularLetterSpacing = "calc((1em / 100) * 2)";
export const mwSemanticChipsFontFamily = "Poppins";
export const mwSemanticChipsFontWeight = 500;
export const mwSemanticChipsLineHeight = "16px";
export const mwSemanticChipsFontSize = "14px";
export const mwCoreColorWhite = "#ffffff";
export const mwCoreColorBlack = "#000000";
export const mwCoreColorTransparent = "#ffffff00";
export const mwCoreColorPink100 = "#F9E2EE";
export const mwCoreColorPink200 = "#F9C7E2";
export const mwCoreColorPink300 = "#FA9EC7";
export const mwCoreColorPink400 = "#F86FA8";
export const mwCoreColorPink500 = "#ed2985";
export const mwCoreColorPink600 = "#c42177";
export const mwCoreColorPink700 = "#991766";
export const mwCoreColorPink800 = "#700f52";
export const mwCoreColorPink900 = "#470b3a";
export const mwCoreColorPink950 = "#22051E";
export const mwCoreColorDarkblue100 = "#2b00ff";
export const mwCoreColorDarkblue200 = "#2600e6";
export const mwCoreColorDarkblue300 = "#20c";
export const mwCoreColorDarkblue400 = "#1b00b3";
export const mwCoreColorDarkblue500 = "#170099";
export const mwCoreColorDarkblue600 = "#170783";
export const mwCoreColorDarkblue700 = "#1a0d73";
export const mwCoreColorDarkblue800 = "#1c145d";
export const mwCoreColorDarkblue900 = "#1e194b";
export const mwCoreColorNeutral50 = "#FAFAFA";
export const mwCoreColorNeutral100 = "#EEF1F3";
export const mwCoreColorNeutral200 = "#CFD6D8";
export const mwCoreColorNeutral300 = "#B1BABE";
export const mwCoreColorNeutral400 = "#95a0a4";
export const mwCoreColorNeutral500 = "#79868b";
export const mwCoreColorNeutral600 = "#5e6d72";
export const mwCoreColorNeutral700 = "#44555b";
export const mwCoreColorNeutral800 = "#2c3e45";
export const mwCoreColorNeutral900 = "#112930";
export const mwCoreColorNeutral950 = "#001418";
export const mwCoreColorBlue100 = "#C8EBFD";
export const mwCoreColorBlue200 = "#97E0FC";
export const mwCoreColorBlue300 = "#0bd2ff";
export const mwCoreColorBlue400 = "#02beed";
export const mwCoreColorBlue500 = "#04a5d2";
export const mwCoreColorBlue600 = "#068eb7";
export const mwCoreColorBlue700 = "#07779d";
export const mwCoreColorBlue800 = "#054d6b";
export const mwCoreColorBlue900 = "#032130";
export const mwCoreColorGreen100 = "#B4FDC1";
export const mwCoreColorGreen200 = "#74FB86";
export const mwCoreColorGreen300 = "#3cfa50";
export const mwCoreColorGreen400 = "#03d303";
export const mwCoreColorGreen500 = "#15b300";
export const mwCoreColorGreen600 = "#2a8000";
export const mwCoreColorGreen700 = "#360";
export const mwCoreColorGreen800 = "#334d00";
export const mwCoreColorGreen900 = "#212903";
export const mwCoreColorYellow100 = "#FBEDBB";
export const mwCoreColorYellow200 = "#FAE39E";
export const mwCoreColorYellow300 = "#FFC533";
export const mwCoreColorYellow400 = "#FFB218";
export const mwCoreColorYellow500 = "#DD8916";
export const mwCoreColorYellow600 = "#975c0b";
export const mwCoreColorYellow700 = "#764706";
export const mwCoreColorYellow800 = "#563305";
export const mwCoreColorYellow900 = "#352107";
export const mwCoreColorRed100 = "#FDD5D3";
export const mwCoreColorRed200 = "#FCBAB7";
export const mwCoreColorRed300 = "#FC8B83";
export const mwCoreColorRed400 = "#FF4433";
export const mwCoreColorRed500 = "#E51B00";
export const mwCoreColorRed600 = "#cb2400";
export const mwCoreColorRed700 = "#9f1b00";
export const mwCoreColorRed800 = "#731700";
export const mwCoreColorRed900 = "#440B05";
export const mwCoreFontSizeScaleDefault = "1px";
export const mwCoreFontSizeScaleMd = "1.25px";
export const mwCoreFontSizeScaleSm = "0.875px";
export const mwCoreFontSizeScaleLg = "1.5px";
export const mwCoreFontSizeScaleXl = "2px";
export const mwCoreFontSizeScale2xl = "2.5px";
export const mwCoreFontSizeScale5xl = "4px";
export const mwCoreFontSizeScale3xl = "3px";
export const mwCoreFontSizeScale4xl = "3.5px";
export const mwCoreFontSizeScale6xl = "4.5px";
export const mwCoreFontSizeScale7xl = "7px";
export const mwCoreFontSizeScaleXs = "1.33px";
export const mwCoreFontSizeScaleXxs = "1.6px";
export const mwCoreFontSizeScaleBase = "16px";
export const mwCoreFontSizeSm = "14px";
export const mwCoreFontSizeRegular = "16px";
export const mwCoreFontSizeMd = "20px";
export const mwCoreFontSizeLg = "24px";
export const mwCoreFontSizeXl = "32px";
export const mwCoreFontSize2xl = "40px";
export const mwCoreFontSize3xl = "48px";
export const mwCoreFontSize4xl = "56px";
export const mwCoreFontSize5xl = "64px";
export const mwCoreFontSize6xl = "72px";
export const mwCoreFontSize7xl = "112px";
export const mwCoreFontSizeXs = "12px";
export const mwCoreFontSizeXxs = "10px";
export const mwCoreFontFontFamiliesHeadlines = "Poppins";
export const mwCoreFontFontFamiliesBody = "Poppins";
export const mwCoreFontFontFamiliesQuote = "Poppins";
export const mwCoreFontLineHeightBase = "24px";
export const mwCoreFontLineHeightScaleDefault = "1px";
export const mwCoreFontLineHeightScaleMd = "1.15px";
export const mwCoreFontLineHeightScaleSm = "0.833px";
export const mwCoreFontLineHeightScaleXs = "0.66px";
export const mwCoreFontLineHeightScaleXxs = "0.5px";
export const mwCoreFontLineHeightScaleLg = "1.5px";
export const mwCoreFontLineHeightScaleXl = "2px";
export const mwCoreFontLineHeightScale2xl = "2.5px";
export const mwCoreFontLineHeightScale3xl = "3px";
export const mwCoreFontLineHeightScale4xl = "3.5px";
export const mwCoreFontLineHeightScale5xl = "4px";
export const mwCoreFontLineHeightScale6xl = "4.5px";
export const mwCoreFontLineHeightScale7xl = "5px";
export const mwCoreFontLineHeightSm = "20px";
export const mwCoreFontLineHeightMd = "28px";
export const mwCoreFontLineHeightRegular = "24px";
export const mwCoreFontLineHeightXs = "16px";
export const mwCoreFontLineHeightLg = "36px";
export const mwCoreFontLineHeightXl = "48px";
export const mwCoreFontLineHeight2xl = "60px";
export const mwCoreFontLineHeight3xl = "72px";
export const mwCoreFontLineHeight4xl = "84px";
export const mwCoreFontLineHeight5xl = "96px";
export const mwCoreFontLineHeight6xl = "108px";
export const mwCoreFontLineHeight7xl = "120px";
export const mwCoreFontLineHeightXxs = "12px";
export const mwCoreFontWeightHeadlinesBold = 700;
export const mwCoreFontWeightHeadlinesRegular = 400;
export const mwCoreFontWeightHeadlinesSemibold = 600;
export const mwCoreFontWeightBodyBold = 700;
export const mwCoreFontWeightBodyRegular = 400;
export const mwCoreFontWeightBodyMedium = 500;
export const mwCoreSpacingLinearBase = "4px";
export const mwCoreSpacingLinearScale = "4px";
export const mwCoreSpacingLinearXs = "4px";
export const mwCoreSpacingLinearSm = "8px";
export const mwCoreSpacingLinearMd = "12px";
export const mwCoreSpacingLinearLg = "16px";
export const mwCoreSpacingLinearXl = "20px";
export const mwCoreSpacingLinear2xl = "24px";
export const mwCoreSpacingLinear3xl = "28px";
export const mwCoreSpacingLinear4xl = "32px";
export const mwCoreSpacingLinearNone = "0px";
export const mwCoreSpacingLinearXxs = "2px";
export const mwCoreSpacingGeometricBase = "2px";
export const mwCoreSpacingGeometricSm = "2px";
export const mwCoreSpacingGeometricMd = "4px";
export const mwCoreSpacingGeometricLg = "8px";
export const mwCoreSpacingGeometricXl = "16px";
export const mwCoreSpacingGeometric2xl = "32px";
export const mwCoreSpacingGeometric3xl = "64px";
export const mwCoreSpacingModularBase = "4px";
export const mwCoreSpacingModularScale = "1.618px";
export const mwCoreSpacingModularXs = "4px";
export const mwCoreSpacingModularSm = "6px";
export const mwCoreSpacingModularMd = "10px";
export const mwCoreSpacingModularLg = "16px";
export const mwCoreSpacingModularXl = "26px";
export const mwCoreSpacingModular2xl = "42px";
export const mwCoreSpacingModular3xl = "68px";
export const mwCoreSizingBase = 4;
export const mwCoreSizingScale = "1.5px";
export const mwCoreSizingDefault = 6;
export const mwCoreSizingXs = 16;
export const mwCoreSizingSm = 28;
export const mwCoreSizingMd = 40;
export const mwCoreSizingLg = 52;
export const mwCoreSizingXl = 64;
export const mwCoreBorderWidthNone = "0px";
export const mwCoreBorderWidthBase = 1;
export const mwCoreBorderWidthScale = 1;
export const mwCoreBorderWidthXs = 1;
export const mwCoreBorderWidthSm = 2;
export const mwCoreBorderWidthMd = 3;
export const mwCoreBorderWidthLg = 4;
export const mwCoreBorderWidthXl = 5;
export const mwCoreLetterSpacingBody = "calc((1em / 100) * 0)";
export const mwCoreLetterSpacingHeadlines = "calc((1em / 100) * -2)";
export const mwCoreLetterSpacingButtons = "calc((1em / 100) * 3)";
export const mwCoreLetterSpacingCaptions = "calc((1em / 100) * 2)";
export const mwCoreTextCaseNone = "none";
export const mwCoreTextCaseCaptions = "uppercase";
export const mwCoreTextCaseButtons = "uppercase";
export const mwCoreTextCaseHeadlines = "none";
export const mwCoreTextDecorationNone = "none";
export const mwCoreTextDecorationButtons = "none";
export const mwCoreTextDecorationCaptions = "none";
export const mwCoreGradientPbg = "linear-gradient(90deg, #ed2985 0%, #0bd2ff 50%, #3cfa50 100%)";
export const mwCoreGradientGbp = "linear-gradient(90deg, #3cfa50 0%, #0bd2ff 48.01%, #ed2985 100%)";
export const mwCoreGradientDarkBlue = "linear-gradient(180deg, #170099 0%, #1d184b 55%)";
export const mwComponentOpacityModalBackdrop = "0.4px";
export const shadowsBlur20 = "3px";
export const shadowsBlur40 = "4px";
export const shadowsBlur60 = "8px";
export const shadowsBlur80 = "16px";
export const shadowsBlur100 = "24px";
export const shadowsBlurBase = "1px";
export const shadowsY20 = "1px";
export const shadowsY40 = "2px";
export const shadowsY60 = "4px";
export const shadowsY80 = "8px";
export const shadowsY100 = "16px";
export const paragraphSpacingDefault = 0;
export const borderRadiusStandardSm = 2;
export const borderRadiusStandardMd = 4;
export const borderRadiusStandardLg = 8;
export const borderRadiusStandardXl = 12;
export const borderRadiusStandard2xl = 16;
export const borderRadiusStandardPill = 9999;
export const borderRadiusStandardCircle = "50px";
export const opacity100 = "1px";
export const opacity000 = 0;
export const opacity010 = "0.1px";
export const opacity020 = "0.2px";
export const opacity030 = "0.3px";
export const opacity040 = "0.4px";
export const opacity050 = "0.5px";
export const opacity060 = "0.6px";
export const opacity070 = "0.7px";
export const opacity080 = "0.8px";
export const opacity090 = "0.9px";
export const opacityElevationNumbra = "0.2px";
export const opacityElevationPenumbra = "0.14px";
export const opacityElevationAmbient = "0.12px";
export const elevation0dp0X = 0;
export const elevation0dp0Y = 0;
export const elevation0dp0Blur = 0;
export const elevation0dp0Spread = 0;
export const elevation0dp0Color = "#00000033";
export const elevation0dp0Type = "dropShadow";
export const elevation0dp1X = 0;
export const elevation0dp1Y = 0;
export const elevation0dp1Blur = 0;
export const elevation0dp1Spread = 0;
export const elevation0dp1Color = "#00000024";
export const elevation0dp1Type = "dropShadow";
export const elevation0dp2X = 0;
export const elevation0dp2Y = 0;
export const elevation0dp2Blur = 0;
export const elevation0dp2Spread = 0;
export const elevation0dp2Color = "#0000001f";
export const elevation0dp2Type = "dropShadow";
export const elevation1dp0X = 0;
export const elevation1dp0Y = "2px";
export const elevation1dp0Blur = "1px";
export const elevation1dp0Spread = "-1px";
export const elevation1dp0Color = "#00000033";
export const elevation1dp0Type = "dropShadow";
export const elevation1dp1X = 0;
export const elevation1dp1Y = "1px";
export const elevation1dp1Blur = "1px";
export const elevation1dp1Spread = 0;
export const elevation1dp1Color = "#00000024";
export const elevation1dp1Type = "dropShadow";
export const elevation1dp2X = 0;
export const elevation1dp2Y = "1px";
export const elevation1dp2Blur = "3px";
export const elevation1dp2Spread = 0;
export const elevation1dp2Color = "#0000001f";
export const elevation1dp2Type = "dropShadow";
export const elevation2dp0X = 0;
export const elevation2dp0Y = "3px";
export const elevation2dp0Blur = "1px";
export const elevation2dp0Spread = "-2px";
export const elevation2dp0Color = "#00000033";
export const elevation2dp0Type = "dropShadow";
export const elevation2dp1X = 0;
export const elevation2dp1Y = "2px";
export const elevation2dp1Blur = "2px";
export const elevation2dp1Spread = 0;
export const elevation2dp1Color = "#00000024";
export const elevation2dp1Type = "dropShadow";
export const elevation2dp2X = 0;
export const elevation2dp2Y = "1px";
export const elevation2dp2Blur = "5px";
export const elevation2dp2Spread = 0;
export const elevation2dp2Color = "#0000001f";
export const elevation2dp2Type = "dropShadow";
export const elevation3dp0X = 0;
export const elevation3dp0Y = "3px";
export const elevation3dp0Blur = "3px";
export const elevation3dp0Spread = "-2px";
export const elevation3dp0Color = "#00000033";
export const elevation3dp0Type = "dropShadow";
export const elevation3dp1X = 0;
export const elevation3dp1Y = "3px";
export const elevation3dp1Blur = "4px";
export const elevation3dp1Spread = 0;
export const elevation3dp1Color = "#00000024";
export const elevation3dp1Type = "dropShadow";
export const elevation3dp2X = 0;
export const elevation3dp2Y = "1px";
export const elevation3dp2Blur = "8px";
export const elevation3dp2Spread = 0;
export const elevation3dp2Color = "#0000001f";
export const elevation3dp2Type = "dropShadow";
export const elevation4dp0X = 0;
export const elevation4dp0Y = "2px";
export const elevation4dp0Blur = "4px";
export const elevation4dp0Spread = "-1px";
export const elevation4dp0Color = "#00000033";
export const elevation4dp0Type = "dropShadow";
export const elevation4dp1X = 0;
export const elevation4dp1Y = "4px";
export const elevation4dp1Blur = "5px";
export const elevation4dp1Spread = 0;
export const elevation4dp1Color = "#00000024";
export const elevation4dp1Type = "dropShadow";
export const elevation4dp2X = 0;
export const elevation4dp2Y = "1px";
export const elevation4dp2Blur = "10px";
export const elevation4dp2Spread = 0;
export const elevation4dp2Color = "#0000001f";
export const elevation4dp2Type = "dropShadow";
export const elevation6dp0X = 0;
export const elevation6dp0Y = "3px";
export const elevation6dp0Blur = "5px";
export const elevation6dp0Spread = "-1px";
export const elevation6dp0Color = "#00000033";
export const elevation6dp0Type = "dropShadow";
export const elevation6dp1X = 0;
export const elevation6dp1Y = "5px";
export const elevation6dp1Blur = "8px";
export const elevation6dp1Spread = 0;
export const elevation6dp1Color = "#00000024";
export const elevation6dp1Type = "dropShadow";
export const elevation6dp2X = 0;
export const elevation6dp2Y = "1px";
export const elevation6dp2Blur = "14px";
export const elevation6dp2Spread = 0;
export const elevation6dp2Color = "#0000001f";
export const elevation6dp2Type = "dropShadow";
export const elevation8dp0X = 0;
export const elevation8dp0Y = "5px";
export const elevation8dp0Blur = "5px";
export const elevation8dp0Spread = "-3px";
export const elevation8dp0Color = "#00000033";
export const elevation8dp0Type = "dropShadow";
export const elevation8dp1X = 0;
export const elevation8dp1Y = "8px";
export const elevation8dp1Blur = "10px";
export const elevation8dp1Spread = "1px";
export const elevation8dp1Color = "#00000024";
export const elevation8dp1Type = "dropShadow";
export const elevation8dp2X = 0;
export const elevation8dp2Y = "3px";
export const elevation8dp2Blur = "14px";
export const elevation8dp2Spread = "2px";
export const elevation8dp2Color = "#0000001f";
export const elevation8dp2Type = "dropShadow";
export const elevation12dp0X = 0;
export const elevation12dp0Y = "7px";
export const elevation12dp0Blur = "8px";
export const elevation12dp0Spread = "-4px";
export const elevation12dp0Color = "#00000033";
export const elevation12dp0Type = "dropShadow";
export const elevation12dp1X = 0;
export const elevation12dp1Y = "12px";
export const elevation12dp1Blur = "17px";
export const elevation12dp1Spread = "2px";
export const elevation12dp1Color = "#00000024";
export const elevation12dp1Type = "dropShadow";
export const elevation12dp2X = 0;
export const elevation12dp2Y = "5px";
export const elevation12dp2Blur = "22px";
export const elevation12dp2Spread = "4px";
export const elevation12dp2Color = "#0000001f";
export const elevation12dp2Type = "dropShadow";
export const elevation16dp0X = 0;
export const elevation16dp0Y = "8px";
export const elevation16dp0Blur = "10px";
export const elevation16dp0Spread = "-5px";
export const elevation16dp0Color = "#00000033";
export const elevation16dp0Type = "dropShadow";
export const elevation16dp1X = 0;
export const elevation16dp1Y = "16px";
export const elevation16dp1Blur = "24px";
export const elevation16dp1Spread = "2px";
export const elevation16dp1Color = "#00000024";
export const elevation16dp1Type = "dropShadow";
export const elevation16dp2X = 0;
export const elevation16dp2Y = "6px";
export const elevation16dp2Blur = "30px";
export const elevation16dp2Spread = "5px";
export const elevation16dp2Color = "#0000001f";
export const elevation16dp2Type = "dropShadow";
export const elevation24dp0X = 0;
export const elevation24dp0Y = "11px";
export const elevation24dp0Blur = "15px";
export const elevation24dp0Spread = "-7px";
export const elevation24dp0Color = "#00000033";
export const elevation24dp0Type = "dropShadow";
export const elevation24dp1X = 0;
export const elevation24dp1Y = "24px";
export const elevation24dp1Blur = "38px";
export const elevation24dp1Spread = "3px";
export const elevation24dp1Color = "#00000024";
export const elevation24dp1Type = "dropShadow";
export const elevation24dp2X = 0;
export const elevation24dp2Y = "9px";
export const elevation24dp2Blur = "46px";
export const elevation24dp2Spread = "8px";
export const elevation24dp2Color = "#0000001f";
export const elevation24dp2Type = "dropShadow";
export const shadowNumbra = "#00000033";
export const shadowPenumbra = "#00000024";
export const shadowAmbient = "#0000001f";